import Http from "./http";

export const resportsAPI = (data) => {
    return Http.post("report/list", data);
};
